export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/FinanceCheckMark.a2e7ca3b.svg","height":13,"width":18,"blurWidth":0,"blurHeight":0};